module.exports = __webpack_public_path__ + "img/hauptseite-kontakt.f0375a21.jpg";